// src/components/PhaseDetailsV2/service.ts
import { apiService } from '@/services/api';
import type { GridViewResponse, GridViewRequestParams } from '@components/GridView/types';

class PhaseDetailsV2Service
{
  /**
   * Fetch conversations for the Phase Details V2 view.
   * POST api/Conversation/GetPhaseDetailsConversationsV2
   */
  async getPhaseDetailsConversations(params: GridViewRequestParams): Promise<GridViewResponse>
  {
    try
    {
      const response = await apiService.post<GridViewResponse>(
        'Conversation/GetPhaseDetailsConversationsV2',
        params,
      );
      return response ?? { Conversations: [] };
    }
    catch (error)
    {
      console.error('Error getting phase details v2 conversations:', error);
      return { Conversations: [] };
    }
  }
}

export const phaseDetailsV2Service = new PhaseDetailsV2Service();
